import { PagePayload } from '@core/interface/core';
import {
  ItAssets,
  ItAssetsType,
  AddItAssetsTypeResponse,
  DeletedItAssetsType,
  Type,
  ItAssetsResponse,
  AddItAssetsResponse,
  DeletedItAssets,
  ItAssetsError,
  ItAssetsCommonResponse,
  AssignAssetPayload,
  DeAssignAssetPayload,
} from '@core/interface/it_assets/itAssets';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ItAssetsActions = createActionGroup({
  source: 'ItAssets',
  events: {
    'Load ItAssets': props<PagePayload>(),
    'Load ItAssets Success': props<ItAssetsResponse>(),
    'Load ItAssets Failure': props<ItAssetsError>(),
    'Add Edit ItAssets': props<{ ItAssets: ItAssets }>(),
    'Add ItAssets Success': props<AddItAssetsResponse>(),
    'Update ItAssets Success': props<AddItAssetsResponse>(),
    'Add ItAssets Failure': props<ItAssetsError>(),
    'Update ItAssets Failure': props<ItAssetsError>(),
    'Delete ItAssets': props<{ id: number }>(),
    'Delete ItAssets Success': props<DeletedItAssets>(),
    'Delete ItAssets Failure': props<ItAssetsError>(),
    'Load ItAssets Type': emptyProps(),
    'Load ItAssets Type Success': props<ItAssetsType>(),
    'Load ItAssets Type Failure': props<ItAssetsError>(),
    'Add Edit ItAssets Type': props<Type>(),
    'Add Edit ItAssets Type Success': props<AddItAssetsTypeResponse>(),
    'Update ItAssets Type Success': props<AddItAssetsTypeResponse>(),
    'Update ItAssets Type Failure': props<ItAssetsError>(),
    'Add Edit ItAssets Type Failure': props<ItAssetsError>(),
    'Delete ItAssets Type': props<{ id: number }>(),
    'Delete ItAssets Type Success': props<DeletedItAssetsType>(),
    'Delete ItAssets Type Failure': props<ItAssetsError>(),
    'Assign Asset': props<AssignAssetPayload>(),
    'Assign Asset Success': props<ItAssetsCommonResponse>(),
    'Assign Asset Failure': props<ItAssetsError>(),
    'DeAssign Asset': props<DeAssignAssetPayload>(),
    'DeAssign Asset Success': props<ItAssetsCommonResponse>(),
    'DeAssign Asset Failure': props<ItAssetsError>(),
    'Reset Delete status': emptyProps(),
  },
});
